<template>
  <!-- prettier-ignore -->
  <div>
    <v-container column>
      <v-card class="pa-5">
        <v-card-title class="justify-center">
          <h2>Terms and Conditions</h2>
        </v-card-title>
        <v-card-text class="pt-5">

          <p class="mb-5"><b><span class="tos-pp-heading">SEERIST
          ANALYTICS MASTER SUBSCRIPTION AND END USER LICENCE AGREEMENT FOR THE HYPERION
          PLATFORM</span></b></p>

          <p><span>These terms and conditions create a contract
          between You and Us (the "<b class="tos-strong">Agreement</b>"). Please read the Agreement
          carefully as this Agreement governs your acquisition and use of our data and
          services. Our service, the Seerist Platform and all data sets integrated into
          the system. If you register for a free or paid trial the Seerist Platform,
          this Agreement will also govern that free or paid trial.</span></p>

          <p><span>If you are
          entering into this Agreement on behalf of a company or other legal entity, you
          represent that you have the authority to bind such entity and its affiliates to
          these terms and conditions, in which case the terms "You" or "Your" shall refer
          to such entity and its affiliates. If you do not have such authority, or if you
          do not agree with these terms and conditions, You must not sign this document
          and You may not use our data and services.</span></p>

          <p><span>You also
          may not access or use our data and services for purposes of monitoring the
          availability, performance or functionality of any Seerist Inc. service or
          for any other benchmarking or competitive purposes. All proprietary rights and
          intellectual property remains the sole property of Us. It is effective between
          You and Us as of the date You accept this Agreement.</span></p>

          <p><b class="tos-strong"><span>1. DEFINITIONS</span></b></p>

          <p><span>"<b class="tos-strong">Affiliate</b>" means any entity which You
          directly or indirectly Control, Controls, indirectly or directly, You, or is
          under common Control with You. "<b class="tos-strong">Control</b>" for purposes of this
          definition, means direct or indirect ownership or control of more than 50% of
          the voting interests of You or an Affiliate.</span></p>


          <p><span>"<b class="tos-strong">Applicable Laws</b>" means any applicable
          law from any jurisdiction from which a User accesses and uses the Seerist
          Platform, or any laws that purport to have jurisdiction and includes all
          applicable Privacy Laws.</span></p>


          <p><span>"<b class="tos-strong">Indexed Content</b>" means information,
          including but not limited to links, posts, and excerpts, that has been obtained
          by Us or on Our behalf from publicly available sources, and data derived
          therefrom, including but not limited to reports, summaries, graphs and charts.
          An individual link, post or excerpt of Indexed Content may be referred to as a
          "<b class="tos-strong">Mention</b>".</span></p>


          <p><span>"<b class="tos-strong">Malicious Code</b>" means viruses, worms,
          time bombs, Trojan horses and other harmful or malicious code, files, scripts,
          agents or programs.</span></p>


          <p><span>"<b class="tos-strong">Non-Social Applications</b>" means online
          applications and offline software products that are provided by entities or
          individuals other than Us and are clearly identified as such, and that
          interoperate with the Seerist Platform.</span></p>


          <p><span>"<b class="tos-strong">Order Form</b>" means the Purchase Order,
          or equivalent document, and any ancillary documents for placing orders for the
          Seerist Platform hereunder that are entered into between You and Us or any of
          Our Affiliates from time to time, including addenda and supplements thereto.
          Order Forms shall be deemed incorporated herein by reference.</span></p>


          <p><span>"<b class="tos-strong">Privacy Laws</b>" means all Applicable
          Laws relating to personal information, privacy and personal data and the
          regulations made thereunder, together with all amendments, restatements and
          replacements made from time to time to such Privacy Laws.</span></p>


          <p><span>"<b class="tos-strong">Purchase Order</b>" means Our standard
          purchase order form or an equivalent form provided by You and approved by Us.</span></p>


          <p><span>"<b class="tos-strong">The Seerist Platform</b>" means the products
          and services offered by Us under the name "Seerist" that You subscribe to from
          Us pursuant to the terms of this Agreement. The Seerist Platform excludes
          Third-Party Social Platforms, Indexed Content, and external data providers.</span></p>


          <p><span>"<b class="tos-strong">Third-Party Social Platform</b>" means a
          third-party social-media website for which You use the Seerist Platform or
          from which We receive Indexed Content for the the Seerist Platform, such as
          Facebook, Twitter, Instagram, or YouTube.</span></p>


          <p><span>"<b class="tos-strong">Users</b>" means individuals who are
          authorized by You to use the Seerist Platform, for whom a subscription to the
          Seerist Platform have been ordered, and who have been supplied user
          identifications and passwords by You (or by Us at Your request). Users may
          include but are not limited to Your employees, consultants, contractors and
          agents, and third parties with which You transact business, but all users are
          bound by the terms and conditions of this Agreement.</span></p>


          <p><span>"<b class="tos-strong">We</b>," "<b class="tos-strong">Us</b>" or "<b class="tos-strong">Our</b>" means
          the Seerist Inc.</span></p>


          <p><span>"<b class="tos-strong">You</b>" or "<b class="tos-strong">Your</b>" means the party
          accepting this Agreement and Affiliates of that party. If You are an agency
          purchasing the Seerist Platform on behalf of Your clients, the terms "You" or
          "Your" shall include such clients, provided that You shall be responsible for
          such clients’ compliance with Your obligations under this Agreement, for any
          breach of those obligations by such clients, and for payment for the Seerist
          Platform purchases on behalf of such clients.</span></p>


          <p><span>"<b class="tos-strong">Your Data</b>" means any electronic data
          or information submitted by You or for You to the Seerist Platform, or is
          collected and processed for You (whether by Us or otherwise) using the Seerist
          Platform, excluding Indexed Content.</span></p>


          <p><b class="tos-strong"><span>2. PURCHASED HYPERION PLATFORM SERVICES</span></b></p>


          <p><span><b class="tos-strong">2.1 Provision of the Seerist Platform</b>.
          We shall make the Seerist Platform available to You pursuant to this Agreement
          and the Order Form during each subscription term set out on the Order Form.</span></p>


          <p><span><b class="tos-strong">2.2 Subscriptions</b>. Unless otherwise
          specified in the Order Form, the Seerist Platform is purchased as subscriptions
          and may be accessed only in accordance with the Order Form and this Agreement.</span></p>


          <p><b class="tos-strong"><span>3. USE OF THE HYPERION PLATFORM</span></b></p>


          <p><span><b class="tos-strong">3.1 Our Responsibilities</b>. We shall: (i)
          provide Our basic support for the Seerist Platform to You at no additional
          charge, and/or upgraded support if purchased; and (ii) use commercially
          reasonable efforts to make the Purchased Seerist Platform available 24 hours a
          day, 7 days a week, except for: (a) planned downtime (of which We shall give at
          least 8 hours notice online via the Seerist Platform or via email or (b) any
          unavailability caused by circumstances beyond Our control. You acknowledge and
          agree that as a service We are not capable of monitoring all Users and
          therefore cannot be held responsible for the manner in which any User uses the
          Indexed Content made available, including if it is in violation of any
          Applicable Laws. You acknowledge and agree that You and all Users shall adhere
          to each of Your Responsibilities as set out in Section 3.4 hereof, which are in
          all cases subject to Our right of termination outlined therein.</span></p>


          <p><span><b class="tos-strong">3.2 Exclusions from Uptime Obligations</b>.
          Notwithstanding Section 3.1 hereof, We shall have no obligation or liability
          relating to problems using the Seerist Platform arising from Your equipment,
          software, hardware, network connections, general internet problems, or any
          integration between Your equipment, software, hardware or network with the
          Seerist Platform or other infrastructure deficiencies related thereto
          attributable to You.</span></p>


          <p><span><b class="tos-strong">3.3 Our Protection of Your Data</b>. We
          shall maintain administrative, physical and technical safeguards for protection
          of the security, confidentiality and integrity of Your Data.</span></p>


          <p><span><b class="tos-strong">3.4 Your Responsibilities</b>.</span></p>


          <p><span><b class="tos-strong">3.4.1 You</b> agree to adhere to the
          stated guidelines and rules of use of all social media networks that contribute
          to Indexed Content and are searched by the Seerist Platform as well as all
          Applicable Laws. For example, with respect to Users that are law enforcement or
          governmental authorities or, in Our reasonable opinion, perform similar
          functions for or on behalf of law enforcement, We will not (i) allow or assist
          You to conduct surveillance on Indexed Content or obtain information on social
          media users or their messages or posts that would require a subpoena, court
          order, or other valid legal process, or that would otherwise have the potential
          to be inconsistent with a social media users’ reasonable expectation of
          privacy; and (ii) display, distribute or otherwise make available Indexed
          Content to any person or entity that We reasonably believe will use such data
          to violate any Applicable Laws. We take the privacy rights of users of
          Third-Party Social Platforms seriously and will enforce our right to suspend
          your service or terminate this Agreement should You violate this Subsection
          3.4.1 or any other similar section contained herein.</span></p>


          <p><span>3.4.2 Each User must ensure that all Applicable
          Laws are adhered to when using the Seerist Platform. If We reasonably believe
          that a User is using the Seerist Platform in violation thereof, We reserve the
          right to immediately terminate that User’s access to the Seerist Platform.</span></p>


          <p><span>3.4.3 You shall: (i) be responsible for Users’
          compliance with this Agreement; (ii) be responsible for the accuracy, quality
          and legality of data or information submitted by You; (iii) use commercially
          reasonable efforts to prevent unauthorized access to or use of the Seerist
          Platform, and notify Us promptly of any such unauthorized access or use; and
          (iv) use the Seerist Platform only in accordance with all Applicable Laws,
          including all existing and future laws addressing or dealing with the privacy
          of social media users.</span></p>


          <p><span>3.4.4 You shall not: (i) make the Seerist
          Platform available to anyone other than Users; (ii) sell, resell, rent, or
          lease the Seerist Platform; (iii) use the Seerist Platform to store or
          transmit Malicious Code; (v) interfere with or disrupt the integrity or
          performance of the Seerist Platform or third-party data contained therein; or
          (vi) attempt to gain unauthorized access to the Seerist Platform or their
          related systems or networks.</span></p>


          <p><span>3.4.5 Use the Seerist Platform (i) to store or
          transmit infringing, libelous, or otherwise unlawful or tortious material, or
          to store or transmit material in violation of third-party rights; (ii) use the
          Seerist Platform to store or transmit Malicious Code; (iii) interfere with or
          disrupt the integrity or performance of the Seerist Platform or third-party
          data contained therein; or (iv) attempt to gain unauthorized access to the
          Seerist Platform or any related systems or networks.</span></p>


          <p><span>3.4.6 You shall not: use the Seerist Platform
          for any activities that could lead to violations of the Universal Declaration
          of Human Rights (</span><a
          href="http://www.un.org/en/documents/udhr/">http://www.un.org/en/documents/udhr/</a><span>).</span></p>


          <p><span><b class="tos-strong">3.5 Usage Limitations</b>. The Seerist
          Platform may be subject to other limitations, which will be outlined in the
          Order Form. We may require You to execute a new Order Form for additional
          Seerist Platform services and You hereby agree to execute such additional
          Order Forms and/or pay such additional invoices, as applicable.</span></p>


          <p><b class="tos-strong"><span>4. INDEXED CONTENT AND THIRD-PARTY SOCIAL
          PLATFORMS</span></b></p>

          <p><span><b class="tos-strong">4.1 Indexed Content</b>. We do not own or
          control Indexed Content. Indexed Content shall not be considered Your Data or
          "Customer Data" under any circumstances, including pursuant to the terms of any
          such other agreement entered into between You and Us for non-Social
          Applications. Indexed Content may be indecent, offensive, inaccurate, unlawful,
          or otherwise objectionable. We shall have no obligation to preview, verify,
          flag, modify, filter, store or remove any Indexed Content, even if requested to
          do so, although We may do so in Our sole discretion.</span></p>


          <p><span>INDEXED CONTENT IS PROVIDED "AS IS," EXCLUSIVE
          OF ANY WARRANTY WHATSOEVER. Your use of Indexed Content is at Your sole risk,
          and We shall not be liable to You or any third party based on Indexed Content.</span></p>


          <p><span><b class="tos-strong">4.2 Third-Party Social Platform Access and
          Interactions</b>. Subject to the terms of this Agreement and the
          confidentiality obligations hereunder, You acknowledge and agree that We may
          access, collect, process, and/or store information or content, regardless of
          whether such content is Your Data or Indexed Content, from such Third-Party
          Social Platform accounts and/or websites in connection with providing the
          Seerist Platform. Except for Our obligations with respect to Your Data, We
          shall not be responsible or liable for: (i) any content provided by You, Your
          Users or any third party to any Third Party Social Platform or other website,
          and any content accessed by You, Your Users or any third party from any
          Third-Party Social Media Platform or other websites; (ii) any interactions or
          communications between You and/or Your Users and any third parties through any
          Third-Party Social Platform or other websites; or (iii) any transactions
          relating to a separate agreement or arrangement between You or Your Users and
          any Third-Party Social Platform provider or website.</span></p>



          <p><b class="tos-strong"><span>5. COMPLIANCE WITH AND CHANGES IN APPLICABLE
          LAWS</span></b></p>


          <p><span><b class="tos-strong">5.1 Changes in Applicable Laws</b>. We shall
          ensure that the Seerist Platform and the storage by us of all Indexed Content
          complies with all Applicable Laws. Each party covenants and agrees with the
          other that it shall notify the other promptly on becoming aware of any changes
          or proposed changes in Applicable Laws that may require a change in the way the
          Seerist Platform is provided or operated in order to maintain compliance with
          Applicable Laws.</span></p>


          <p><span><b class="tos-strong">5.2 Minimize Disruption</b>. If We implement
          any changes to the Seerist Platform required in order to bring the Seerist
          Platform in compliance with amendments to Applicable Laws, We shall take
          reasonable steps to minimize disruption caused in the provision of the Seerist
          Platform when doing so.</span></p>


          <p><b class="tos-strong"><span>6. FEES AND PAYMENT FOR PURCHASED HYPERION
          PLATFORM SERVICES</span></b></p>


          <p><span><b class="tos-strong">6.1 Fees</b>. You shall pay all fees
          specified in all Order Forms hereunder. Except as otherwise specified herein or
          in an Order Form, (i) fees are based on services purchased and not actual
          usage, (ii) payment obligations are non-cancelable and fees paid are non-
          refundable, except in the event of termination or breach of this Agreement is
          effected under Section 4.3 (<b class="tos-strong">Termination for Unavailability of Certain
          Third-Party Social Platforms</b>) or service availability is less than 95% up
          time on a monthly basis and (iii) quantities purchased cannot be decreased
          during the relevant subscription term stated on the Order Form.</span></p>


          <p><span><b class="tos-strong">6.2 Invoicing and Payment</b>. You will
          provide Us with a valid purchase order or alternative document reasonably
          acceptable to Us. If You provide credit card information to Us, You authorize
          Us to charge such credit card for all Seerist Platform services listed in the
          Order Form for the term and any renewal thereof as set forth in Section 12.2
          (Term of Purchased Subscriptions).</span></p>


          <p><span><b class="tos-strong">6.3 Overdue Charges</b>. If any amounts
          invoiced are not received by Us by the due date stipulated on the Order Form or
          in accordance with this Agreement, as applicable, then, without limiting Our
          rights or remedies, such charges may accrue late interest at the rate of 1.5%
          (on a compounded monthly basis) of the outstanding balance per month, or the
          maximum rate permitted by law, whichever is lower.</span></p>


          <p><span><b class="tos-strong">6.4 Suspension of the Seerist Platform and
          Acceleration</b>. If any amount owing by You under this or any other agreement
          for Our services (including, for clarity, the Seerist Platform) is 30 days or more
          overdue (or 10 days or more overdue in the case of amounts You have authorized
          Us to charge to Your credit card), We may, without limiting Our other rights
          and remedies, accelerate Your unpaid fee obligations under such agreements so
          that all such obligations become immediately due and payable, and suspend Our
          services to You until such amounts are paid in full.</span></p>


          <p><b class="tos-strong"><span>7. PROPRIETARY RIGHTS</span></b></p>


          <p><span><b class="tos-strong">7.1 Reservation of Rights</b>. Subject to
          the limited rights expressly granted hereunder, We reserve all rights, title
          and interest in and to the Seerist Platform, including all related
          intellectual property rights. No rights are granted to You hereunder other than
          as expressly set forth herein.</span></p>


          <p><span><b class="tos-strong">7.1.1 Ownership and Use of Your Data</b>.
          You retain all rights, title and interest in and to Your Data, and Seerist
          acknowledges that it neither owns nor acquires any additional rights
          in and to Your Data not expressly granted by this agreement. We further
          acknowledge that You retain the rights to use Your Data for any purpose in Your
          sole discretion. Subject to the foregoing, You hereby grant to Us a
          non-exclusive, non-transferable right and license to use Your Data during the
          term for the limited purposes of performing Our obligations under this
          agreement.</span></p>


          <p><span><b class="tos-strong">7.1.2 Ownership of Seerist Inc.
          Offering and Data Sets</b>. Subject to the rights granted in this Agreement, Seerist
          retains all right, title and interest in and to the Seerist Platform
          offerings and data sets, and You acknowledge that You neither own nor acquire
          any additional rights in and to the foregoing not expressly granted by this
          agreement or any licenses to the software used to provide the Seerist
          Platform. You further acknowledge that Seerist Inc. retains the right to
          use the foregoing for any purpose in Our sole discretion. The Parties
          acknowledge that all data sets are "Seerist Inc. Confidential
          Information" and neither You nor any Authorized User shall have the right to
          disclose, copy, disseminate, distribute, publish, display or sublicense all or
          any portion of such data sets without Our prior written consent in each
          instance.</span></p>


          <p><span><b class="tos-strong">7.2 Restrictions</b>. You shall not: (i) in
          the course of using the Seerist Platform, access or use Third-Party Social
          Platforms, Your Data, or any Indexed Content in violation of any Applicable
          Laws or the terms of services for any Third Party Platform searched in
          connection with Your use of the Seerist Platform; (ii) display, distribute or
          make available the Indexed Content to any third party, provided such restriction
          does not apply to (a) aggregations of Indexed Content which do not reveal
          individual Mentions, or (b) content retrieved directly from a Third Party
          Platform rather than using the Seerist Platform; (iii) permit any third party
          to access the Seerist Platform except as permitted herein or in an Order Form;
          (iv) create derivative works based on the Seerist Platform except as permitted
          herein; (v) copy, modify, or create derivative works based on Indexed Content
          except to create aggregations of Indexed Content which do not reveal individual
          Mentions; (vi) copy, frame, or mirror any part or content of the Seerist
          Platform, other than copying or framing on Your own intranets or otherwise for
          Your own internal business purposes; (vii) decompile, disassemble, reverse
          engineer or otherwise attempt to obtain or perceive the source code from which
          any software component of the Seerist Platform; (viii) access the Seerist
          Platform in order to (a) build a competitive product or service, or (b) copy
          any features, functions or graphics of the Seerist Platform.</span></p>


          <p><span><b class="tos-strong">7.3 Suggestions</b>. We shall have a
          royalty-free, worldwide, irrevocable, perpetual license to use and incorporate
          into the Seerist Platform any suggestions, enhancement requests,
          recommendations, or other feedback provided by You, including Users, relating
          to the operation of the Seerist Platform.</span></p>


          <p><span><b class="tos-strong">7.4 Federal Government End Use Provisions</b>.
          Where applicable, the Seerist Platform, including related software and
          technology, to the federal government of the United States of America in
          accordance with the Federal Acquisition Regulations ("<b class="tos-strong">FAR</b>") and Defense
          Federal Acquisition Regulations Supplement ("<b class="tos-strong">DFARS</b>") pursuant to FAR
          12.211 (Technical Data) and FAR 12.212 (Software) and, for Department of
          Defense transactions, DFARS 252.227-7015 (Technical Data – Commercial Items)
          and DFARS 227.7202-3 (Rights in Commercial Computer Software or Computer
          Software Documentation).</span></p>


          <p><span><b class="tos-strong">7.5 Additional Government Provisions</b>. If
          a government agency has a need for rights not granted under these terms, it
          must negotiate with Us to determine if there are acceptable terms for
          transferring such rights, and a mutually acceptable written addendum
          specifically conveying such rights must be included in any applicable
          agreement.</span></p>


          <p><b class="tos-strong"><span>8. CONFIDENTIALITY</span></b></p>


          <p><span><b class="tos-strong">8.1 Definition of Confidential Information</b>.
          As used herein, "<b class="tos-strong">Confidential Information</b>" means all confidential
          information disclosed by a party to this Agreement (a "<b class="tos-strong">Disclosing Party</b>")
          to the other party to this Agreement (a "<b class="tos-strong">Receiving Party</b>"), whether
          orally or in writing, that is designated as confidential or that reasonably
          should be understood to be confidential given the nature of the information and
          the circumstances of disclosure. Your Confidential Information shall include
          Your Data; Our Confidential Information shall include the Seerist Platform;
          and Confidential Information of each party shall include the terms and
          conditions of this Agreement and all Order Forms, as well as business and
          marketing plans, technology and technical information, product plans and
          designs, and business processes disclosed by such party. However, Confidential
          Information shall not include any information that (i) is or becomes generally
          known to the public without breach of any obligation owed to the Disclosing Party;
          (ii) was known to the Receiving Party prior to its disclosure by the Disclosing
          Party without breach of any obligation owed to the Disclosing Party; (iii) is
          received from a third party without breach of any obligation owed to the
          Disclosing Party; or (iv) was independently developed without the use of
          Confidential Information by the Receiving Party.</span></p>


          <p><span><b class="tos-strong">8.2 Protection of Confidential Information</b>.
          The Receiving Party shall (i) use the same degree of care that it uses to
          protect the confidentiality of its own confidential information of like kind
          (but in no event less than reasonable care), (ii) not use any Confidential
          Information of the Disclosing Party for any purpose outside the scope of this
          Agreement, and (iii) except as otherwise authorized by the Disclosing Party in
          writing, to limit access to Confidential Information of the Disclosing Party to
          those of its and its Affiliates’ employees, contractors and agents who need
          such access for purposes consistent with this Agreement and who have signed
          agreements with the Receiving Party containing protections no less stringent
          than those herein. Neither party shall disclose the terms of this Agreement or
          any Order Form to any third party other than its Affiliates or Users and their
          legal counsel and accountants without the other party’s prior written consent.</span></p>


          <p><span><b class="tos-strong">8.3 Compelled Disclosure</b>. The Receiving
          Party may make disclosures of Confidential Information as required by court
          order provided that the Receiving Party uses all commercially reasonable
          efforts to limit disclosure and to obtain confidential treatment or a
          protective order, has provided reasonable notice to the Disclosing Party and an
          opportunity to object, and has allowed the Disclosing Party to participate in
          the proceeding to limit or prevent the disclosure of any Confidential
          Information.</span></p>


          <p><span><b class="tos-strong">8.4 Duplication of Confidential Information</b>.
          The Receiving Party will at all times limit the duplication of Confidential
          Information to only the number of copies reasonably required to adhere to its
          obligations hereunder. Within 20 days after receipt of the Disclosing Party’s
          written request, the Receiving Party will, at the Receiving Party’s sole
          option, either return all originals and copies of the Confidential Information
          in ever media in the Receiving Party’s possession or control, or destroy all
          such originals and copies and certify in writing to such destruction and the
          destruction method used. To the extent applicable law does not permit the
          Receiving Party to destroy any Confidential Information, the Receiving Party
          will notify the Disclosing Party of such applicable law and the required
          retention period and permit the Disclosing Party to respond to such
          requirement. The Receiving Party will continue to be bound by this Section for
          any retained Confidential Information (if any).</span></p>


          <p><span><b class="tos-strong">8.5 Survival re Confidential Information</b>.
          The parties obligations regarding Confidential Information under this Article
          8, shall apply for 3 years after the date a party receives such Confidential
          Information.</span></p>

          <p><b class="tos-strong"><span>9. WARRANTIES, EXCLUSIVE REMEDIES AND
          DISCLAIMERS</span></b></p>


          <p><span><b class="tos-strong">9.1 Representations</b>. Each party
          represents that it has validly entered into this Agreement and has the legal
          power to do so.</span></p>


          <p><span><b class="tos-strong">9.2 Our Warranties</b>. Subject to Section
          3.2 (Exclusions Uptime Obligations), We warrant that the functionality of the
          Seerist Platform will not be materially decreased during a subscription term
          and the Seerist Platform will be free from viruses and Malicious Code.</span></p>


          <p><span><b class="tos-strong">9.3 Your Warranties</b>. You warrant that:
          (i) that you will not do anything to discredit the reputation, name, goodwill
          of Us or any product or service of Ours including, for clarity, the Seerist
          Platform; (ii) that you will not do anything to adversely affect the Seerist
          Platform or any software or platform in relation thereto or associated with the
          operation thereof; (iii) that you will not detrimentally effect or adversely
          affect the functionality of the Seerist Platform; (iv) you will not allow any
          Malicious Code to interfere with the proper operation of the Seerist Platform;
          (v) you will not disseminate or promulgate any Confidential Information,
          proprietary information or intellectual property belonging to Us or any third
          party to a third party unless you have our written consent to do so; (vi) you
          will not breach any term or conditions of this Agreement or do anything which
          would have any averse effect upon us in any way as a result of entering into
          this Agreement with you.</span></p>


          <p><span><b class="tos-strong">9.4 Disclaimer</b>. EXCEPT AS EXPRESSLY
          PROVIDED HEREIN, NEITHER PARTY MAKES ANY WARRANTIES OF ANY KIND, WHETHER
          EXPRESS, IMPLIED, STATUTORY OR OTHERWISE, AND EACH PARTY SPECIFICALLY DISCLAIMS
          ALL IMPLIED WARRANTIES, INCLUDING ANY WARRANTIES OF MERCHANTABILITY OR FITNESS
          FOR A PARTICULAR PURPOSE, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW.
          THE INDEXED CONTENT IS PROVIDED "AS IS," "AS AVAILABLE," WITH NO WARRANTY OF
          ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY OR OTHERWISE. THE HYPERION
          PLATFORM PROVIDED UNDER A FREE TRIAL AT NO CHARGE ARE PROVIDED "AS IS",
          EXCLUSIVE OF ANY WARRANTY OR AVAILABILITY COMMITMENT WHATSOEVER. EACH PARTY
          DISCLAIMS ALL LIABILITY AND INDEMNIFICATION OBLIGATIONS FOR ANY HARM OR DAMAGES
          CAUSED BY ANY THIRD-PARTY HOSTING PROVIDERS.</span></p>


          <p><b class="tos-strong"><span>10. MUTUAL INDEMNIFICATION</span></b></p>


          <p><span><b class="tos-strong">10.1 Indemnification by Us</b>. We shall
          indemnify and defend You against any claim, demand, suit, or proceeding made or
          brought against You by a third party alleging that the use of the Seerist
          Platform as permitted hereunder infringes or misappropriates the intellectual
          property rights of a third party or violates any Privacy Laws (a "<b class="tos-strong">Claim
          Against You</b>"), provided that You: (a) promptly give Us written notice of
          the Claim Against You; (b) give Us sole control of the defense and settlement
          of the Claim Against You (provided that We may not settle any Claim Against You
          unless the settlement unconditionally releases You of all liability); and (c)
          provide to Us all reasonable assistance, at Our expense. We shall have no
          obligation to indemnify You to the extent any Claim Against You arises from
          Indexed Content, a Third-Party Social Platform, Your breach of the terms of
          this Agreement or actions of a third party hosting provider.</span></p>


          <p><span><b class="tos-strong">10.2 Indemnification by You</b>. You shall
          indemnify and defend Us against any claim, demand, suit or proceeding made or
          brought against Us by a third party not caused in any way by us alleging that
          Your Data, or Your use of the Seerist Platform, a Third Party Social Platform,
          or Indexed Content in breach of this Agreement, infringes or misappropriates
          the intellectual property rights of a third party or violates any Privacy Laws
          (a "<b class="tos-strong">Claim Against Us</b>"), and shall indemnify Us for any damages, legal
          fees and costs finally awarded against Us as a result of, or for any amounts
          paid by Us under a court- approved settlement of, a Claim Against Us; provided
          that We (a) promptly give You written notice of the Claim Against Us; (b) give
          You sole control of the defense and settlement of the Claim Against Us
          (provided that You may not settle any Claim Against Us unless the settlement
          unconditionally releases Us of all liability); and (c) provide to You all
          reasonable assistance, at Your expense. In the event We receive information
          regarding an actual or potential Claim Against Us, We may, in Our discretion,
          require You to immediately, upon receipt of notice from Us, discontinue all use
          of any Indexed Content or Your Data that may be related to an actual or
          potential Claim Against Us and, to the extent not prohibited by law, delete
          from Your systems any such Indexed Content or delete or permit Us to delete
          from the Seerist Platform, any of Your Data, in each case within five days of
          receipt of notice from Us. You shall, if so requested by Us, certify such
          deletion and discontinuance of use in writing. We shall be authorized to
          provide a copy of such certification to the third party claimant; You shall
          indemnify and defend Us against any claim, demand, suit or proceeding made or
          brought against Us by a third party not caused in any way by us</span></p>


          <p><span><b class="tos-strong">10.3 Exclusive Remedy</b>. This Section 10
          (Mutual Indemnification) states the indemnifying party’s sole liability to, and
          the indemnified party’s exclusive remedy against, the other party for any type
          of claim described in this Section.</span></p>

          <p><b class="tos-strong"><span>11. LIMITATION OF LIABILITY</span></b></p>


          <p><span><b class="tos-strong">11.1 Limitation of Liability</b>. WITH THE
          EXCEPTION OF A BREACH OF SECTION 10.1 (Indemnification by Us), NEITHER PARTY'S
          LIABILITY WITH RESPECT TO ANY SINGLE INCIDENT ARISING OUT OF OR RELATED TO THIS
          AGREEMENT SHALL EXCEED THE AMOUNT PAID BY YOU HEREUNDER IN THE 12 MONTHS
          PRECEDING THE INCIDENT, PROVIDED THAT IN NO EVENT SHALL EITHER PARTY’S
          AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THIS AGREEMENT EXCEED THE
          TOTAL AMOUNT PAID BY YOU HEREUNDER. THE ABOVE LIMITATIONS WILL APPLY WHETHER AN
          ACTION IS IN CONTRACT OR TORT AND REGARDLESS OF THE THEORY OF LIABILITY, THE
          FOREGOING SHALL NOT LIMIT YOUR PAYMENT OBLIGATIONS UNDER SECTION 6 (FEES AND
          PAYMENT FOR PURCHASED HYPERION PLATFORM SERVICES).</span></p>


          <p><span><b class="tos-strong">11.2 Exclusion of Consequential and Related
          Damages</b>. IN NO EVENT SHALL EITHER PARTY HAVE ANY LIABILITY TO THE OTHER
          PARTY FOR ANY LOST PROFITS OR REVENUES OR FOR ANY INDIRECT, SPECIAL,
          INCIDENTAL, CONSEQUENTIAL, COVER OR PUNITIVE DAMAGES HOWEVER CAUSED, WHETHER IN
          CONTRACT, TORT OR UNDER ANY OTHER THEORY OF LIABILITY, AND WHETHER OR NOT THE
          PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE FOREGOING
          DISCLAIMER SHALL NOT APPLY TO THE EXTENT PROHIBITED BY APPLICABLE LAW.
          NOTWITHSTANDING THE FOREGOING, THIS SECTION WILL NOT APPLY TO THE EXTENT SUCH
          CLAIMS ARE CAUSED BY A BREACH OF ARTICLE 8 (CONFIDENTIALITY).</span></p>


          <p><b class="tos-strong"><span>12. TERM AND TERMINATION</span></b></p>


          <p><span><b class="tos-strong">12.1 Term of Agreement</b>. This Agreement
          commences on the date You accept it by signing below and continues until all
          subscriptions granted in accordance with this Agreement have expired or been
          terminated.</span></p>


          <p><span><b class="tos-strong">12.2 Term of Purchased Subscriptions</b>.
          Subscriptions purchased by You commence on the start date specified in the
          applicable Order Form and continue for the subscription term specified therein.
          Except as otherwise specified in the applicable Order Form, all subscriptions
          shall automatically renew for additional periods equal to the expiring
          subscription term or one year (whichever is shorter), unless either party gives
          the other notice of nonrenewal at least 30 days before the end of the relevant
          subscription term. The per-unit pricing during any such renewal term shall be
          the same as that during the prior term unless We have given You written notice
          of a pricing increase at least 60 days before the end of such prior term, in
          which case the pricing increase shall be effective upon renewal and thereafter.
          Any such pricing increase shall be generally applied to all customers of the
          Seerist Platform, unless (i) the pricing applied to you in any previous term
          was designated in the relevant Order Form as promotional or one-time, or (ii)
          such other customers have specific pricing increase prohibitions or limits as
          set out on in their Order Forms.</span></p>


          <p><span><b class="tos-strong">12.3 Termination for Cause</b>. Either party
          may terminate this Agreement for any material breach by the other party that is
          not cured within 15 days of notice being delivered to the party in breech or if
          the other party becomes the subject of a petition in bankruptcy or any other
          proceeding relating to insolvency, receivership, liquidation or assignment for
          the benefit of creditors.</span></p>


          <p><span><b class="tos-strong">12.4 Refund or Payment upon Termination</b>.
          Upon any termination in accordance with Section 12.3 by You, We shall refund
          You any prepaid fees covering the remainder of the term of all subscriptions
          after the effective date of termination. Upon any termination by Us, You shall
          pay any unpaid fees covering the remainder of the term of all subscriptions set
          out in the applicable Order Forms after the effective date of termination. In
          no event shall any termination relieve You of the obligation to pay any fees
          payable to Us for the period prior to the effective date of termination.</span></p>


          <p><span><b class="tos-strong">12.5 Surviving Provisions</b>. Section 4.1
          (Indexed Content), 4.3 (Termination for Unavailability of Certain Third- Party
          Social Platforms), 12.4 (Refund or Payment upon Termination) and (Surviving
          Provisions), as well as Articles 6 (Fees and Payment for Purchased Seerist
          Platform Services), 7 (Proprietary Rights), 9 (Warranties, Exclusive Remedies
          and Disclaimer), 10 (Mutual Indemnification), 111 (Limitation of Liability), 13
          (Notices, Governing Law and Jurisdiction), and 14 (General Provisions) shall
          survive any termination or expiration of this Agreement.</span></p>


          <p><b class="tos-strong"><span>13. NOTICES, GOVERNING LAW AND JURISDICTION</span></b></p>

          <p><span><b class="tos-strong">13.1 General</b>. All notices under this
          Agreement shall be delivered to Us at the following address:</span></p>

          <p class="ml-5">
            Miles &amp; Stockbridge P.C. <br/>
            100 Light Street <br/>
            Baltimore, MD 21202 <br/>
            Attn: Matthew D. Klaiber <br/>
            Email: <a href="mailto:mklaiber@MilesStockbridge.com" target="_blank">mklaiber@MilesStockbridge.com</a>
          </p>

          <p><span><b class="tos-strong">13.2 Governing Law</b>. The governing law of
          this Agreement is the law of the State of Virginia and the federal laws of the
          United States applicable therein, and any lawsuits arising out of or in
          connection with this Agreement shall be adjudicated by the courts of competent
          jurisdiction in the State of Virginia without regard to choice or conflicts of
          law rules.</span></p>


          <p><span><b class="tos-strong">13.3 Manner of Giving Notice</b>. Except as
          otherwise specified in this Agreement, all notices, permissions and approvals
          hereunder shall be in writing and shall be deemed to have been given upon: (i)
          personal delivery; (ii) the fifth business day after mailing; (iii) the first
          business day after sending by email. Billing-related notices to You shall be
          addressed to the relevant billing contact designated by You and all other
          notices to You shall be delivered to the address stipulated on the Order Form,
          as that address may be changed by You from time to time.</span></p>


          <p><span><b class="tos-strong">13.4 Waiver of Jury Trial</b>. Each party
          hereby waives any right to jury trial in connection with any action or
          litigation in any way arising out of or related to this Agreement.</span></p>


          <p><b class="tos-strong"><span>14. GENERAL PROVISIONS</span></b></p>



          <p><span><b class="tos-strong">14.1 Export Compliance</b>. The Seerist
          Platform, other technology We make available, and derivatives thereof may be
          subject to export laws and regulations of the United States, Canada and other
          jurisdictions. Each party represents that it is not named on any U.S.
          government denied-party list. You shall not permit Users to access or use the
          Seerist Platform in a U.S.-embargoed country (currently Cuba, Iran, North
          Korea, Sudan, or Syria) or in violation of any applicable export law or regulation.</span></p>


          <p><span><b class="tos-strong">14.2 Anti-Corruption</b>. You represent and
          warrant that You have not received or been offered any illegal or improper
          bribe, kickback, payment, gift, or thing of value from any of Our employees or
          agents in connection with this Agreement. Reasonable inducements, gifts and
          entertainment provided in the ordinary course of business do not violate the
          above restriction. If You learn of any violation of the above restriction, You
          will use reasonable efforts to promptly send notice to Our Chief Executive Officer
          in accordance with this Agreement.</span></p>

          <p><span><b class="tos-strong">14.3 Relationship of the Parties</b>. The
          parties are independent contractors. This Agreement does not create a
          partnership, franchise, joint venture, agency, fiduciary, or employment
          relationship between the parties.</span></p>


          <p><span><b class="tos-strong">14.4 No Third-Party Beneficiaries</b>. There
          are no third-party beneficiaries to this Agreement.</span></p>


          <p><span><b class="tos-strong">14.5 Waiver</b>. No failure or delay by
          either party in exercising any right under this Agreement shall constitute a
          waiver of that right.</span></p>


          <p><span><b class="tos-strong">14.6 Severability</b>. If any provision of
          this Agreement is held by a court of competent jurisdiction to be contrary to
          law, the provision shall be modified by the court and interpreted so as best to
          accomplish the objectives of the original provision to the fullest extent
          permitted by law, and the remaining provisions of this Agreement shall remain
          in effect.</span></p>


          <p><span><b class="tos-strong">14.7 Legal Fees</b>. You shall pay on demand
          all of Our reasonable legal fees and other costs incurred by Us to collect any
          fees or charges due Us under this Agreement following Your breach of Section
          5.2 (Invoicing and Payment).</span></p>


          <p><span><b class="tos-strong">14.8 Assignment</b>. Neither party may
          assign any of its rights or obligations hereunder, whether by operation of law
          or otherwise, without the prior written consent of the other party (not to be
          unreasonably withheld). Notwithstanding the foregoing, either party may assign
          this Agreement in its entirety (including all Order Forms), without consent of
          the other party, in connection with a merger, acquisition, corporate
          reorganization, or sale of all or substantially all of its assets not involving
          a direct competitor of the other party. A party’s sole remedy for any purported
          assignment by the other party in breach of this section 13.8 shall be, at the
          non-assigning party’s election, termination of this Agreement upon written
          notice to the assigning party. Subject to the foregoing, this Agreement shall
          bind and inure to the benefit of the parties, their respective successors and
          permitted assigns.</span></p>


          <p><span><b class="tos-strong">14.9 Entire Agreement</b>. This Agreement is
          the entire agreement between You and Us regarding your use of the Seerist
          Platform and supersedes all prior and contemporaneous agreements, proposals or
          representations, written or oral, concerning its subject matter. No
          modification, amendment, or waiver of any provision of this Agreement shall be
          effective unless in writing and either signed or accepted electronically by the
          party against whom the modification, amendment, or waiver is to be asserted.
          The parties agree that any term or condition stated in Your purchase order or
          in any other of Your other documentation (excluding Order Forms) is void. In
          the event of any conflict or inconsistency between the provisions in the body
          of this Agreement and any any Order Form, the terms of such Order Form shall
          prevail.</span></p>


          <p><span><b class="tos-strong">14.10</b> This Agreement is to be binding upon the
          heirs, executors, assigns, officers and directors of the Parties hereto.</span></p>


        </v-card-text>
      </v-card>
      <div class="accept_column">
        <input v-model="accepted" type="checkbox">
        <v-btn :class="accepted ? '' : 'btnDisabled'" color="#4b49ff" class="accept_button ml-3" @click="acceptTerms()">I accept the terms and
          conditions
        </v-btn>
        <Loader v-if="processing" color="black" text=""></Loader>
      </div>
    </v-container>
  </div>
</template>

<script>
import { getIdToken } from "@/common/storage";
import { acceptTermsService } from "@/services/user/user.service";
import router from "@/router";

export default {
  name: "Eula",
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
  data: () => ({
    accepted: false,
    processing: false,
  }),
  async mounted() {
    let token = await getIdToken();
    if (!token) {
      router.push("/");
    }
  },
  methods: {
    acceptTerms: async function () {
      if (!this.accepted) {
        return false;
      }
      this.processing = true;
      const result = await acceptTermsService();
      if (result) {
        router.push({ name: "home" });
      }
      this.processing = false;
    },
  },
};
</script>

<style scoped>
.bg {
  background: #191a1a;
  color: #fff;
}

.v-card {
  height: calc(100vh - 125px);
  overflow-y: scroll;
  overflow-x: hidden;
}

.accept_button {
  color: white;
}

.accept_column {
  text-align: center;
  margin: 10px;
}

.tos-pp-heading {
  font-family: "TruenoRg";
  font-size: 16px;
  color: #148ecd;
}

.tos-strong {
  font-family: "TruenoRg";
}

.tos-pp-item {
  display: table-cell;
}

.tos-pp-indent {
  display: table-cell;
  width: 4em;
}

.tos-pp-indent-2 {
  display: table-cell;
  width: 8em;
}

.tos-pp-indent-3 {
  display: table-cell;
  width: 12em;
}

.btnDisabled {
  cursor: default;
  opacity: 0.5;
}
</style>
